// Field Type Constants
export const TEXT_FIELDTYPE = 'com.atlassian.jira.plugin.system.customfieldtypes:textfield';
export const TEXT_AREA_FIELDTYPE = 'com.atlassian.jira.plugin.system.customfieldtypes:textarea';
export const DATE_PICKER_FIELDTYPE = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
export const NUMBER_FIELDTYPE = 'com.atlassian.jira.plugin.system.customfieldtypes:float';
export const DATE_TIME_FIELDTYPE = 'com.atlassian.jira.plugin.system.customfieldtypes:datetime';
export const LABEL_FIELDTYPE = 'com.atlassian.jira.plugin.system.customfieldtypes:labels';
export const SELECT_FIELDTYPE = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
export const CASCADING_SELECT_FIELDTYPE =
	'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect';
export const CHECKBOX_FIELDTYPE =
	'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes';
export const USERPICKER_FIELDTYPE = 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker';
export const MULTI_USERPICKER_FIELDTYPE =
	'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker';
export const MULTI_SELECT_FIELDTYPE =
	'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';
export const RADIO_BUTTON_FIELDTYPE =
	'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons';
export const URL_FIELDTYPE = 'com.atlassian.jira.plugin.system.customfieldtypes:url';

export const SUMMARY_FIELDTYPE = 'summary';
export const ENVIRONMENT_FIELDTYPE = 'environment';
export const COMMENT_FIELDTYPE = 'comment';
export const STATUS_FIELDTYPE = 'status';
export const CATEGORY_FIELDTYPE = 'com.atlassian.jira.plugin.system.customfieldtypes:jwm-category';
// this is for hierarchy mapping
export const EPIC_FIELDTYPE = 'epic';
export const REPORTER_FIELDTYPE = 'reporter';
export const ASSIGNEE_FIELDTYPE = 'assignee';
export const ISSUETYPE_FIELDTYPE = 'issuetype';
export const CREATOR_FIELDTYPE = 'creator';
export const CREATED_FIELDTYPE = 'created';
export const UPDATED_FIELDTYPE = 'updated';
export const DESCRIPTION_FIELDTYPE = 'description';
export const PRIORITY_FIELDTYPE = 'priority';
export const DUEDATE_FIELDTYPE = 'duedate';
export const RESOLUTION_FIELDTYPE = 'resolution';
export const VOTES_FIELDTYPE = 'votes';
export const TIME_SPENT_FIELDTYPE = 'timespent';
export const TIME_REMAINING_ESTIMATE_FIELDTYPE = 'timeestimate';
export const TIME_ORIGINAL_ESTIMATE_FIELDTYPE = 'timeoriginalestimate';
export const WORKLOG_FIELDTYPE = 'worklog';
export const SYSTEM_LABELS_FIELDTYPE = 'labels';
// NOTE: Watches is the correct spelling for the Watchers field type in Jira
export const WATCHERS_FIELDTYPE = 'watches';
export const PARENT_FIELDTYPE = 'parent';
export const ISSUEID_FIELDTYPE = 'issueId';
// common for all issue link types(outward/inward)
export const ISSUE_LINKS_FIELDTYPE = 'issuelinks';
export const userFieldTypes = new Set([
	ASSIGNEE_FIELDTYPE,
	CREATOR_FIELDTYPE,
	REPORTER_FIELDTYPE,
	USERPICKER_FIELDTYPE,
	MULTI_USERPICKER_FIELDTYPE,
]);

export type FieldName = string;
export type FieldId = string;
export type FieldDirection = string;
export type CustomFieldType =
	| typeof TEXT_FIELDTYPE
	| typeof TEXT_AREA_FIELDTYPE
	| typeof DATE_PICKER_FIELDTYPE
	| typeof NUMBER_FIELDTYPE
	| typeof LABEL_FIELDTYPE
	| typeof SELECT_FIELDTYPE
	| typeof CASCADING_SELECT_FIELDTYPE
	| typeof CHECKBOX_FIELDTYPE
	| typeof USERPICKER_FIELDTYPE
	| typeof MULTI_USERPICKER_FIELDTYPE
	| typeof DATE_TIME_FIELDTYPE
	| typeof MULTI_SELECT_FIELDTYPE
	| typeof RADIO_BUTTON_FIELDTYPE
	| typeof URL_FIELDTYPE;

export type JiraFieldType = string;

export type ThirdPartyFieldId = string;
export type ThirdPartyFieldType = string;
export type ThirdPartyFieldName = string;

export type ThirdPartyField = {
	fieldId: ThirdPartyFieldId;
	fieldName: ThirdPartyFieldName;
	fieldType: ThirdPartyFieldType;
};

export type Field = {
	fieldType: JiraFieldType;
	fieldName: FieldName;
	fieldId?: FieldId | null; // Field id if field already exists in Jira
	fieldDirection?: FieldDirection;
};

export type LinkName = string;
export type LinkId = string;
export type LinkDirection = string;
export type IssueLink = {
	linkName: LinkName;
	linkId: LinkId;
	linkDirection: LinkDirection;
};

export const supportedCustomFieldTypes: Set<CustomFieldType> = new Set([
	TEXT_FIELDTYPE,
	TEXT_AREA_FIELDTYPE,
	DATE_PICKER_FIELDTYPE,
	NUMBER_FIELDTYPE,
	LABEL_FIELDTYPE,
	SELECT_FIELDTYPE,
	CASCADING_SELECT_FIELDTYPE,
	CHECKBOX_FIELDTYPE,
	USERPICKER_FIELDTYPE,
	MULTI_USERPICKER_FIELDTYPE,
	DATE_TIME_FIELDTYPE,
	MULTI_SELECT_FIELDTYPE,
	RADIO_BUTTON_FIELDTYPE,
	URL_FIELDTYPE,
]);
